import React from 'react';
import { motion } from 'framer-motion';

const AnimatedText = ({ children, className = "", delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.6 }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const ColorChangingText = ({ children, className = "" }) => {
  return (
    <motion.span
      animate={{ color: ['#66023c', '#cc7f3b', '#c08081', '#66023c'] }}
      transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
      className={className}
    >
      {children}
    </motion.span>
  );
};

export default AnimatedText;